import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=c4832cdc"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports